import { LIST_OF_GROUPS_CANCEL_SEARCH } from 'mk/autogenerated/translations/SearchResults.342e0b95e12c86e3b8d4e74cfd14416e'
import Btn, { BtnType } from 'mk2/components/Btn';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import { LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './SearchResults.mscss';

interface SearchResultsOwnProps {
    loadingState: LoadingState;
    hasData: boolean;
    onCancelFilters(event: React.MouseEvent<HTMLButtonElement>);
}

export default class SearchResults extends React.PureComponent<SearchResultsOwnProps> {
    public render() {
        const { children, hasData, loadingState, onCancelFilters } = this.props;

        return (
            <div className={styles.SearchResults}>
                {(loadingState === LoadingState.INIT || loadingState === LoadingState.LOADING && !hasData) ? (
                    <LoadingPlaceholder width={200} />
                ) : (
                    children
                )}
                <Btn
                    type={BtnType.Link}
                    label={LIST_OF_GROUPS_CANCEL_SEARCH}
                    onClick={onCancelFilters}
                />
            </div>
        );
    }
}
